import { render, staticRenderFns } from "./Tabs1Demo.vue?vue&type=template&id=0fe22e1f&scoped=true&"
import script from "./Tabs1Demo.vue?vue&type=script&lang=js&"
export * from "./Tabs1Demo.vue?vue&type=script&lang=js&"
import style0 from "./Tabs1Demo.vue?vue&type=style&index=0&id=0fe22e1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe22e1f",
  null
  
)

export default component.exports